import firebase from 'firebase/app';
export function toArray<T>(querySnapshot: firebase.firestore.QuerySnapshot<firebase.firestore.DocumentData>) {
  const result = [];
  querySnapshot.forEach(d => {
    result.push({ id: d.id, ...d.data() });
  });
  return result as T[];
}
